import type { GQL_ID } from '@@partner:types:graphql'

import React, { useState } from 'react'
import { useFetchCategoriesChainsFromIds } from '@@partner:graphql/query/category/categoriesChainFromIds.gql'

import { Button } from 'rsuite'
import IconPlus from '@rsuite/icons/Plus'
import ProductCategoriesPickerModal from './ProductCategoriesPickerModal'
import ProductCategoriesSelectedItems from './ProductCategoriesSelectedItems'

export interface ProductCategoriesManagerProps {
  value?: GQL_ID[]
  onChange: (path: GQL_ID[]) => void
}

export default function ProductCategoriesManager ({
  value = [],
  onChange
}: ProductCategoriesManagerProps) {
  const [ modalOpen, setModalOpen ] = useState<boolean>(false)

  const {
    data: valueData,
    previousData: valuePreviousData,
    loading
  } = useFetchCategoriesChainsFromIds(value)

  const handleDropCategory = (dropId: GQL_ID) => {
    const filtered = value.filter((s) => s !== dropId)
    onChange?.(filtered)
  }

  return (
    <div className="relative">
      <ProductCategoriesSelectedItems
        loading={loading}
        items={
          valueData?.categoriesChainsFromIds ||
          valuePreviousData?.categoriesChainsFromIds
        }
        onCategoryDrop={handleDropCategory}
      />

      <Button
        size="xs"
        color="violet"
        appearance="primary"
        onClick={() => setModalOpen(true)}
      >
        <IconPlus /> Добавить категории
      </Button>

      <ProductCategoriesPickerModal
        onChange={onChange}
        open={modalOpen}
        value={value}
        onClose={() => setModalOpen(false)}
      />
    </div>
  )
}
